export default __webpack_public_path__ + "static/media/ransomwaredesktop.d3c058bc.png";